import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import React, { Component } from 'react';
import styles from './css/Hint.scss';

export class RegionSidebar extends Component {
    static propTypes = {
        order: ImmutablePropTypes.map.isRequired,
        regions: ImmutablePropTypes.map.isRequired,
    }

    render() {
        const { order, regions } = this.props;
        const region = order.get('region');

        if (!region) {
            return <span />;
        }

        return (
            <p className={styles.hint}>
                <FormattedMessage id={regions.getIn([region, 'alias'])} />
            </p>
        );
    }
}

export default connect(state => ({
    order: state.order,
    regions: state.regions,
}))(RegionSidebar);
